import React, { useEffect } from 'react';
import HeroSection from './HeroSection';
import PersonalAppSection from './PersonalAppSection';
import TestimonialsSection from './TestimonialsSection';
import SectionNavigator from './SectionNavigator';
import { useSectionScroll } from '../hooks/useSectionScroll';

const SECTIONS = ['hero', 'app-section', 'testimonials-section'];

const MainPage: React.FC = () => {
  const { currentSection, isScrolling, scrollToSection } = useSectionScroll({
    sections: SECTIONS,
    transitionDuration: 800,
    scrollThreshold: 50,
  });

  // Disable default scroll restoration
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    
    // Start at the top on load
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HeroSection />
      <PersonalAppSection />
      <TestimonialsSection />
      
      <SectionNavigator
        sections={SECTIONS}
        currentSection={currentSection}
        onSectionClick={scrollToSection}
        isScrolling={isScrolling}
      />
    </>
  );
};

export default MainPage;
